<template>
    <div>
        <div style="display: flex;align-items: center;justify-content: space-between;">
            <a-breadcrumb style="margin: 16px 0">
                <a-breadcrumb-item>主页</a-breadcrumb-item>
                <a-breadcrumb-item>{{ selectFirstMenu }}</a-breadcrumb-item>
                <a-breadcrumb-item>{{ selectSecondMenu }}</a-breadcrumb-item>
            </a-breadcrumb>
            <div>
                <a-button icon="sync" @click="apiPromotionChargesList">刷新</a-button>
            </div>
        </div>

        <a-collapse expandIconPosition="right" activeKey="1">
            <a-collapse-panel key="1" header="推广流水查询">
                <div class="qinang-search-row">
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">费用类型：</div>
                        <a-select v-model="query.chargesType" @change="resetChargesState()">
                            <a-select-option :value="0">全部</a-select-option>
                            <a-select-option :value="1">奖金入账</a-select-option>
                            <a-select-option :value="-1">提现</a-select-option>
                            <a-select-option :value="2">提现失败退回</a-select-option>
                        </a-select>
                    </div>
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">奖金状态：</div>
                        <a-select v-model="query.chargesState">
                            <a-select-option :value="0">全部</a-select-option>
                            <a-select-option v-if="query.chargesType == 0 || query.chargesType == 1"
                                :value="4">冻结待核销</a-select-option>
                            <a-select-option v-if="query.chargesType != -1" :value="3">已入账</a-select-option>
                            <a-select-option v-if="query.chargesType == 0 || query.chargesType == -1"
                                :value="5">提现中</a-select-option>
                            <a-select-option v-if="query.chargesType == 0 || query.chargesType == -1"
                                :value="6">提现失败</a-select-option>
                            <a-select-option :value="7">提现成功</a-select-option>
                        </a-select>

                    </div>
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">推广人：</div>
                        <a-input placeholder="请输入推广人姓名" v-model="query.promoterName" />
                    </div>
                </div>
                <div class="qinang-margin-top-12 qinang-search-row">
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">查询日期：</div>
                        <a-date-picker v-model="query.startTime" format="YYYY-MM-DD"
                            class="qinang-search-time-picker-2" />
                        <span style="width: 20px;text-align: center;">-</span>
                        <a-date-picker class="qinang-search-time-picker-2" v-model="query.endTime"
                            format="YYYY-MM-DD" />
                    </div>
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">被推广人：</div>
                        <a-input placeholder="请输入被推广人姓名" v-model="query.bePromotedName" />
                    </div>
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">订单编号：</div>
                        <a-input placeholder="请输入订单编号" v-model="query.orderId" />
                    </div>
                </div>
                <div class="qinang-margin-top-12 qinang-search-row">
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">服务商：</div>
                        <a-select v-model="query.facilitatorId" @change="apiPromotionChargesList">
                            <a-select-option :value="0">全部</a-select-option>
                            <a-select-option v-for="(item, index) in facilitatorList" :key="index"
                                :value="item.facilitatorId">{{ item.facilitatorName }}</a-select-option>
                        </a-select>
                    </div>
                </div>

                <div class="qinang-margin-top-12 qinang-search-row" style="justify-content: center;">
                    <a-button type="primary" icon="search" @click="apiPromotionChargesList">查询</a-button>
                    <a-button icon="redo" @click="apiPromotionChargesList" style="margin-left: 14px;">重置</a-button>
                </div>
            </a-collapse-panel>
        </a-collapse>

        <div class="qinang-card">
            <a-table :columns="tableColumns" :data-source="tableData" row-key="promotionChargesId"
                :loading="tableLoading" :pagination="false">
                <span slot="chargesType" slot-scope="text, record">
                    <span v-if="record.chargesType == 1">奖金入账</span>
                    <span v-if="record.chargesType == -1">提现</span>
                    <span v-if="record.chargesType == 2">提现失败退回</span>
                </span>
                <span slot="money" slot-scope="text, record">
                    {{ (record.money / 100).toFixed(2) }}
                </span>
                <span slot="surplusPrice" slot-scope="text, record">
                    {{ (record.surplusPrice / 100).toFixed(2) }}
                </span>
                <span slot="chargesState" slot-scope="text, record">
                    {{chargesStateMap.find(item => item.value === record.chargesState)?.label || record.chargesState}}
                </span>
                <span slot="createTime" slot-scope="text, record">
                    {{ qaUtil.timeFormat(record.createTime) }}
                </span>
                <span slot="orderId" slot-scope="text, record">
                    <a-button v-if="record.orderId" type="link" @click="showOrderDetail(record)">{{ record.orderId
                    }}</a-button>
                    <span v-else>-</span>
                </span>
                <span slot="tableAction" slot-scope="text, record">
                    <a-button type="link" @click="showDetail(record)">详情</a-button>
                </span>
            </a-table>
            <a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total"
                :default-page-size="query.size" show-size-changer show-quick-jumper size="small"
                :page-size-options="['10', '20', '50']" :show-total="total => `共 ${total} 条记录`" @change="pageChange"
                @showSizeChange="showSizeChange" />
        </div>

        <a-modal class="qa-modal-half" width="600px" title="推广流水详情" :visible="detailVisible" @ok="detailVisible = false"
            @cancel="detailVisible = false" :maskClosable="false" :keyboard="false">


            <a-descriptions bordered :column="1" size="small" v-if="detailData">
                <a-descriptions-item label="流水ID">{{ detailData.promotionChargesId }}</a-descriptions-item>
                <a-descriptions-item label="订单编号">{{ detailData.orderId }}</a-descriptions-item>
                <a-descriptions-item label="银行流水号">{{ detailData.serialNo }}</a-descriptions-item>
                <a-descriptions-item label="推广人">{{ detailData.realName }}</a-descriptions-item>
                <a-descriptions-item label="被推广人">{{ detailData.bePromotedName }}</a-descriptions-item>
                <a-descriptions-item label="费用账户">
                    {{ detailData.sourceType == 1 ? '团队账户' : '个人账户' }}
                </a-descriptions-item>
                <a-descriptions-item label="费用类型">
                    {{ detailData.chargesType == 1 ? '奖金入账' : (detailData.chargesType == -1 ? '提现' : '提现失败退回') }}
                </a-descriptions-item>
                <a-descriptions-item label="金额(元)">{{ (detailData.money / 100).toFixed(2) }}</a-descriptions-item>
                <a-descriptions-item label="变动前余额(元)">{{ (detailData.beforeSurplusPrice / 100).toFixed(2)
                }}</a-descriptions-item>
                <a-descriptions-item label="余额(元)">{{(detailData.surplusPrice / 100).toFixed(2)}}</a-descriptions-item>
                <a-descriptions-item label="奖金状态">
					{{ (chargesStateMap.find(item => item.value === detailData.chargesState) || {}).label || detailData.chargesState }}
                </a-descriptions-item>
                <a-descriptions-item label="创建时间">{{ qaUtil.timeFormat(detailData.createTime) }}</a-descriptions-item>
                <a-descriptions-item label="更新时间">{{ detailData.updateTime ? qaUtil.timeFormat(detailData.updateTime) :
                    '-' }}</a-descriptions-item>

            </a-descriptions>

        </a-modal>

        <a-modal class="qa-modal" width="100%" title="订单详情" :visible="orderDetailVisible"
            @ok="orderDetailVisible = false" @cancel="orderDetailVisible = false" :maskClosable="false"
            :keyboard="false">
            <OrderInfo v-if="orderDetailVisible" :ordersNumber="orderNumber"></OrderInfo>
        </a-modal>

    </div>
</template>

<script>
import moment from 'moment'
import OrderInfo from './OrderInfo.vue';
export default {
    components: {
        OrderInfo,
    },
    data() {
        return {
            moment,
            selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
            selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
            detailVisible: false,
            detailData: null,
            orderDetailVisible: false,
            orderNumber: undefined,

            query: {
                page: 1,
                size: 10,
                total: 0,
                facilitatorId: 0,
                chargesType: 0,
                chargesState: 0,
                orderId: undefined,
                promoterName: undefined,
                bePromotedName: undefined,
                startTime: moment().format('YYYY-MM-DD'),
                endTime: moment().format('YYYY-MM-DD'),
            },

            tableData: [],
            facilitatorList: [],
            tableColumns: [
                { title: '流水ID', dataIndex: 'promotionChargesId', key: 'promotionChargesId', align: 'center' },
                { title: '订单编号', key: 'orderId', align: 'center', scopedSlots: { customRender: 'orderId' } },

                { title: '推广人', dataIndex: 'realName', key: 'realName', align: 'center' },
                { title: '被推广人', dataIndex: 'bePromotedName', key: 'bePromotedName', align: 'center' },
                { title: '费用类型', key: 'chargesType', align: 'center', scopedSlots: { customRender: 'chargesType' } },
                { title: '金额(元)', key: 'money', align: 'center', scopedSlots: { customRender: 'money' } },
                { title: '余额(元)', key: 'surplusPrice', align: 'center', scopedSlots: { customRender: 'surplusPrice' } },
                { title: '奖金状态', key: 'chargesState', align: 'center', scopedSlots: { customRender: 'chargesState' } },
                { title: '创建时间', key: 'createTime', align: 'center', scopedSlots: { customRender: 'createTime' } },
                { title: '操作', key: 'tableAction', align: 'center', scopedSlots: { customRender: 'tableAction' } },
            ],
            tableLoading: false,
            chargesStateMap: [
                { label: '冻结待核销', value: 4 },
                { label: '已入账', value: 3 },
                { label: '提现中', value: 5 },
                { label: '提现失败', value: 6 },
                { label: '提现成功', value: 7 },
            ],
        };
    },
    methods: {
        async apiFacilitatorListForStaff() {
            const { data: res } = await this.$http.post(this.navigation.apiFacilitatorListForStaff, { staffId: window.sessionStorage.getItem('staffId') });
            if (res.code == 200) {
                this.facilitatorList = res.data
            } else {
                this.$message.error(res.msg)
            }
        },

        async apiPromotionChargesList() {
            let queryData = JSON.parse(JSON.stringify(this.query))
            if (queryData.orderId === 0) queryData.orderId = null
            if (queryData.chargesType === 0) queryData.chargesType = null
            if (queryData.chargesState === 0) queryData.chargesState = null
            if (queryData.facilitatorId === 0) queryData.facilitatorId = null
            queryData.startTime = this.moment(queryData.startTime).format('YYYY-MM-DD')
            queryData.endTime = this.moment(queryData.endTime).format('YYYY-MM-DD')
            this.tableLoading = true
            const { data: res } = await this.$http.post(this.navigation.apiPromotionChargesList, queryData);
            if (res.code == 200) {
                this.tableData = res.data.list
                this.query.page = res.data.pages.page
                this.query.size = res.data.pages.size
                this.query.total = res.data.pages.total
                this.tableLoading = false
            } else {
                this.$message.error(res.msg)
                this.tableLoading = false
            }
        },
        async showDetail(record) {
            const { data: res } = await this.$http.post(this.navigation.apiPromotionChargesDetail, { promotionChargesId: record.promotionChargesId });
            if (res.code == 200) {
                this.detailData = res.data
                this.detailVisible = true
            } else {
                this.$message.error(res.msg)
            }
        },
        pageChange(page, pageSize) {
            this.query.page = page
            this.query.size = pageSize
            this.apiPromotionChargesList()
        },
        showSizeChange(current, size) {
            this.query.page = current
            this.query.size = size
            this.apiPromotionChargesList()
        },
        resetChargesState() {
            this.query.chargesState = 0
        },
        showOrderDetail(record) {
            this.orderNumber = record.orderId
            this.orderDetailVisible = true
        },

    },
    created() {
        this.apiFacilitatorListForStaff()
        this.apiPromotionChargesList()
    }
};
</script>

<style scoped></style>
